<template>
  <!-- 职工维权问答 -->
  <div class="protection-cont">
    <div class="eprights-cont">
      <div class="left-tabs">
        <a class="active">法律法规</a>
        <a @click="gotoZSWD">职工维权知识问答</a>
      </div>
      <div class="right-laws">
        <h3 class="titleh3">法律法规</h3>
        <ul class="laws-box">
          <li class="cur" @click="gotoDetail(item)" v-for="(item,index) in list" :key="index">
            <div class="whitebg">
              <h4>{{item.doc_title}}
                <!--                <span class="tag">最新</span>-->
              </h4>
              <div class="time-box">
                <i class="iconfont"></i>
                发布日期：{{item.compose_time}}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
var _czc = _czc || [];
(function () {
  var um = document.createElement("script");
  um.src = "https://v1.cnzz.com/z.js?id=1281457519&async=1";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(um, s);
})();
  import {getDocumentList} from '@/api/document';

  export default {
    name: 'EpRightsProtection',
    data() {
      return {
        params: {
          chan_id: 1,page:1,rows:9999
        },
        list: []
      }
    },
    mounted() {
      this.getDocumentList()
    },
    methods: {
      getDocumentList() {
        getDocumentList(this.params).then(res => {
          this.list = res.items
        })
      },
      gotoDetail: function (item) {
        let routeUrl = this.$router.resolve({name: 'Regulations1', query: {doc_id: item.pkid}});
        window.open(routeUrl.href, '_blank');
      },
      gotoZSWD: function () {
        this.$router.push({name: 'LawsRegulations'})
      },
    }
  };
</script>
<style scoped>
  .eprights-cont {
    display: flex;
  }

  .left-tabs {
    width: 260px;
    text-align: center;
    padding-top: 20px;
  }

  .left-tabs a {
    display: inline-block;
    width: 220px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    font-size: 18px;
    color: #666;
    background: #fafbfc;
    border: 1px solid #d9dfe8;
    box-sizing: border-box;
  }

  .left-tabs a + a {
    margin-top: 10px;
  }

  .left-tabs a.active {
    color: #0079df;
    background: #f3f9ff;
    border: 1px solid #78c1ff;
  }

  .right-laws {
    flex: 1;
    padding-top: 10px;
  }

  .laws-box {
    clear: both;
    overflow: hidden;
  }

  .laws-box li {
    width: 296px;
    list-style: none;
    position: relative;
    height: 90px;
    background: url("~@/assets/images/border.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    border: 2px solid #e4f2ff;
    cursor: pointer;
    float: left;
  }

  .laws-box li h4 {
    font-size: 15px;
    font-weight: bold;
    font-family: '微软雅黑';
    color: #333;
    line-height: 1;
    margin-bottom: 10px;
    padding-top: 14px;
    display: inline-block;
    position: relative;
  }

  .laws-box li .time-box {
    font-size: 14px;
    color: #999;
    line-height: 1;
  }

  .laws-box li .tag {
    display: inline-block;
    width: 36px;
    height: 15px;
    font-size: 12px;
    color: #fff;
    background: url('~@/assets/images/new.png') no-repeat;
    padding-left: 9px;
    box-sizing: border-box;
    line-height: 15px;
    position: absolute;
    right: -40px;
  }

  .whitebg {
    background: #fff;
    width: 286px;
    height: 80px;
    margin: 0 auto;
    margin-top: 3px;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .laws-box li:hover {
    border: 2px solid #63b4ff;
  }

  .laws-box li {
    margin-right: 15px;
    margin-bottom: 15px;
  }
</style>
